import { render } from "./TaskCard.vue?vue&type=template&id=cd980ee6&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=cd980ee6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cd980ee6"

export default script